export async function getLsQuestions({ token, themeName }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getLsQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themeName }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to fetch questions");
  }

  return resp.json();
}
